import { Action, createReducer, on } from '@ngrx/store';

import * as UserGameProfileActions from './user-game-profile.actions';

export const USER_GAME_PROFILE_FEATURE_KEY = 'userGameProfile';

export interface UserGameProfileState {
  saving: boolean; // has the UserGameProfile list been loaded
  error?: string | null; // last known error (if any)
}

export interface UserGameProfilePartialState {
  readonly [USER_GAME_PROFILE_FEATURE_KEY]: UserGameProfileState;
}

export const initialUserGameProfileState: UserGameProfileState = {
  // set initial required properties
  saving: false,
};

const reducer = createReducer(
  initialUserGameProfileState,
  on(UserGameProfileActions.saveUserGameProfile, (state) => ({
    ...state,
    saving: true,
    error: null,
  })),
  on(UserGameProfileActions.saveUserGameProfileSuccess, (state) => ({
    ...state,
    saving: false,
  })),
  on(UserGameProfileActions.saveUserGameProfileFailure, (state, { error }) => ({
    ...state,
    saving: false,
    error,
  })),
);

export function userGameProfileReducer(
  state: UserGameProfileState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
